import ApplicationLogoValour from "./ApplicationLogoValour";
import ApplicationLogoUC from "./ApplicationLogoUC";
import ApplicationLogoQL from "./ApplicationLogoQL";
import ApplicationLogoQLSquare from "./ApplicationLogoQLSquare";

export default function ApplicationLogo(props) {
    if (process.env.REACT_APP_CUSTOM_LOGO) {
        const logoSrc = process.env.REACT_APP_CUSTOM_LOGO.startsWith('http') 
            ? process.env.REACT_APP_CUSTOM_LOGO 
            : `/images/${process.env.REACT_APP_CUSTOM_LOGO}`;
        return <img src={logoSrc} alt="Logo" className={props.className} />;
    }

    if (window.location.hostname === "valour-api.romiapp.co.za" && process.env.REACT_APP_COLOUR === "QP") {
        return <ApplicationLogoValour {...props} />;
    }

    if (process.env.REACT_APP_COLOUR === "UC") {
        return <ApplicationLogoUC {...props} />;
    }

    if (props.square) {
        return <ApplicationLogoQLSquare {...props} />;
    }

    return <ApplicationLogoQL {...props} />;
}
